<template lang="pug">
  .report-review
    table.table.table-bordered.table-middle
      tbody
        tr.centered
          th
            a.text-dark(href="javascript:void(0)" data-toggle="tooltip" data-placement="top" title="現在このページから配信されている画像データのサイズです。")
              i.mdi.mdi-cloud-download.m-r-5
              | オリジナル画像データ
          th
            a.text-dark(href="javascript:void(0)" data-toggle="tooltip" data-placement="top" title="画像データをダウンロードに対する増減です。")
              i.mdi.mdi-download.m-r-5
              | 画像データの増減
          th
            a.text-dark(href="javascript:void(0)" data-toggle="tooltip" data-placement="top" title="画像の読み込みにかかる時間が短縮され、ストレスによる離脱を防ぎます。")
              i.mdi.mdi-clock-fast.m-r-5
              | 読み込み時間
          th
            a.text-dark(href="javascript:void(0)" data-toggle="tooltip" data-placement="top" title="モバイル通信で閲覧しているユーザーの実質的な負担金額が軽減されます。")
              i.mdi.mdi-heart.m-r-5
              | ギガ節約
          th
            a.text-dark(href="javascript:void(0)" data-toggle="tooltip" data-placement="top" title="従量制のクラウドプラットフォームを利用している場合はコストダウンに繋がります。")
              i.mdi.mdi-cash-multiple.m-r-5
              | クラウド料金
        tr.centered
          td
            .text-xl
              Filesize(v-bind:value="summary.images.orig.total")
            strong.text-muted
              | ページ全体の
              Percentage(v-bind:value="summary.images.orig.total / summary.pages.orig.total" textClass="text-muted")


          td
            .text-xl
              Filesize(v-bind:value="maxReduced" expectMinus)
            .text-ul
              Percentage(v-bind:value="maxReducedRate" expectMinus)
          th
            div.text-ul.text-success
              Second(v-bind:value="shorten" expectMinus)
            .text-muted
              | ※1
          th
            .text-xl.text-success
              Price(v-bind:value="gigaDown" digits="1" expectMinus)
            .text-muted
              | 1PVあたり
              sup ※2
          th
            .text-xl.text-success
              Price(v-bind:value="priceDown" expectMinus)
            .text-muted
              | 100万PVあたり
              sup ※3
    p.text-muted.text-right.text-center
      small ※1 実効スループットを{{mbps}}Mbpsと仮定
      small(style="padding-left: 10px") ※2 NTTドコモ 1GBプラン{{gigaPrice.toLocaleString()}}円を仮定
      small(style="padding-left: 10px") ※3 CloudFrontの日本向け配信料金を参考に1GBあたり{{this.gbPrice}}円を仮定

</template>

<style lang="scss">
.report-review {
  table
    tr.centered {
      td, th {
        text-align: center;
      }
    }
}
</style>

<script>
import Filesize from '@/components/common/Filesize'
import Percentage from '@/components/common/Percentage'
import Second from '@/components/common/Second'
import Price from '@/components/common/Price'

export default {
  components: {
    Filesize,
    Percentage,
    Second,
    Price,
  },
  props: {
    summary: Object,
    mbps: {
      type: Number,
      default: 10,
    },
    gigaPrice: {
      type: Number,
      default: 2900,
    },
    gbPrice: {
      type: Number,
      default: 12.5,
    },
  },
  computed: {
    maxReduced() {
      const best = this.summary.images[this.summary.best]
      return best.saved
    },
    maxReducedRate() {
      return this.maxReduced / this.summary.images.orig.total;
    },
    shorten() {
      const reduced = this.maxReduced;
      const bytesPerSec = this.mbps * 1024 * 1024  / 8,
        sec = reduced / bytesPerSec;
      return sec;
    },
    gigaDown() {
      const gb = this.maxReduced / (1024 * 1024 * 1024);
      const price = gb * this.gigaPrice;
      return price;
    },
    priceDown() {
      const gb = this.maxReduced * 1000000 / (1024 * 1024 * 1024);
      const price = gb * this.gbPrice;
      return price;
    },
    hasWebp() {
      return this.summary.webp && this.summary.webp.count > 0;
    }
  },
  mounted() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
  }
}
</script>